import { useEffect, useState } from "react";
import {
  printByCategory,
  printByStencil,
  printUncut,
} from "../../../lib/services/printingService";
import { useStencilWeeks } from "../../../lib/hooks/useStencilWeeks";
import { useStencils } from "../../../lib/hooks/useStencils";

/* Centered modal with backdrop */
const PrintPopup = ({ onClose }) => {
  const [type, setType] = useState("category");

  const { stencilWeeks, setStencilWeeks } = useStencilWeeks();
  const { stencils } = useStencils();

  // Close with ESC key
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  async function getPdf(res, fileName) {
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "stencils.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  const PrintCategory = () => {
    const [category, setCategory] = useState(1);

    // Prompt the response pdf to be downloaded
    async function print(e) {
      e.preventDefault();
      const res = await printByCategory(category);

      if (!res.ok) {
        alert("There was an error printing.");
        return;
      }

      await getPdf(res, `category-${category}-stencils.pdf`);

      // Map stencil weeks with updated print values
      const newSWs = stencilWeeks.map((week) => {
        const stencil = stencils.find((s) => week.stencil_id === s.id);

        if (stencil.category_id === category) {
          return {
            ...week,
            printed: 3,
          };
        }
        return week;
      });

      setStencilWeeks(newSWs);

      onClose();
    }

    return (
      <form onSubmit={print}>
        <div style={{ display: "flex" }}>
          <label htmlFor="category_id">Category Number</label>
          <input
            id="category_id"
            type="number"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
        </div>

        <button type="submit">Print</button>
      </form>
    );
  };

  const PrintUncut = () => {
    const [category, setCategory] = useState(1);

    async function print(e) {
      e.preventDefault();
      const res = await printUncut(category);

      if (!res.ok) {
        alert("There was an error printing.");
        return;
      }

      await getPdf(res, `uncut-stencils.pdf`);

      // Map stencil weeks with updated print values
      const newSWs = stencilWeeks.map((week) => {
        if (week.cut < 3) {
          return {
            ...week,
            printed: 3,
          };
        }
        return week;
      });

      setStencilWeeks(newSWs);

      onClose();
    }
    return (
      <form onSubmit={print}>
        <div style={{ display: "flex" }}>
          <label htmlFor="category_id">Category Number</label>
          <input
            id="category_id"
            type="number"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
        </div>
        <button type="submit">Print</button>
      </form>
    );
  };

  const PrintIndividual = () => {
    const [stencil, setStencil] = useState("");

    async function print(e) {
      e.preventDefault();
      const res = await printByStencil(stencil);

      if (!res.ok) {
        alert("There was an error printing.");
        return;
      }

      await getPdf(res, `${stencil}.pdf`);

      // Map stencil weeks with updated print values
      const newSWs = stencilWeeks.map((week) => {
        if (week.stencil_id === stencil) {
          return {
            ...week,
            printed: 3,
          };
        }
        return week;
      });

      setStencilWeeks(newSWs);

      onClose();
    }

    return (
      <form onSubmit={print}>
        <div style={{ display: "flex" }}>
          <label htmlFor="stencil_id">Stencil ID</label>
          <input
            id="stencil_id"
            type="text"
            value={stencil}
            onChange={(e) => setStencil(e.target.value)}
          />
        </div>

        <button type="submit">Print</button>
      </form>
    );
  };

  return (
    <div className="confirm-overlay" role="presentation" onClick={onClose}>
      {/* stop propagation so clicks inside the card don't close */}
      <div
        className="confirm-card"
        role="dialog"
        aria-modal="true"
        style={{
          width: "auto",
          backgroundColor: "rgb(237, 71, 9)",
          outline: "none",
          border: "none",
          color: "white",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="confirm-text">Print Stencils</p>

        <div className="confirm-actions mb-3">
          <label>How would you like to print stencils?</label>
          <select onChange={(e) => setType(e.target.value)} name="type">
            <option value="category">By Category</option>
            <option value="uncut">Uncut Stencils</option>
            <option value="individual">Individual Stencil</option>
          </select>
        </div>

        {type === "category" && <PrintCategory />}
        {type === "uncut" && <PrintUncut />}
        {type === "individual" && <PrintIndividual />}
      </div>
    </div>
  );
};

export default PrintPopup;
